var _rect, _path, _path2, _path3, _g, _g2, _g3, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 800,
    viewBox: "0 0 1440 800",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 800,
    fill: "#27173A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-100,240 C100,160 350,40 500,100 C650,160 750,280 900,240 C1050,200 1200,80 1440,150 L1440,800 L-100,800 Z",
    fill: "#321c4c",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-100,300 C150,220 350,180 550,240 C750,300 900,220 1050,280 C1200,340 1350,300 1440,250 L1440,800 L-100,800 Z",
    fill: "#3d2159",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-100,400 C50,380 200,320 400,360 C600,400 800,360 1000,400 C1200,440 1350,380 1440,340 L1440,800 L-100,800 Z",
    fill: "#4a2868",
    opacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 150,
    r: 5,
    fill: "#e0aaff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 180,
    r: 3,
    fill: "#e0aaff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 160,
    r: 4,
    fill: "#e0aaff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 170,
    r: 3,
    fill: "#e0aaff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 100,
    r: 5,
    fill: "#e0aaff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 130,
    r: 3,
    fill: "#e0aaff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 840,
    cy: 110,
    r: 4,
    fill: "#e0aaff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 780,
    cy: 120,
    r: 3,
    fill: "#e0aaff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1200,
    cy: 200,
    r: 5,
    fill: "#e0aaff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1220,
    cy: 230,
    r: 3,
    fill: "#e0aaff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1240,
    cy: 210,
    r: 4,
    fill: "#e0aaff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1180,
    cy: 220,
    r: 3,
    fill: "#e0aaff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 150,
    x2: 240,
    y2: 160,
    stroke: "#e0aaff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 150,
    x2: 180,
    y2: 170,
    stroke: "#e0aaff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 150,
    x2: 210,
    y2: 180,
    stroke: "#e0aaff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 100,
    x2: 840,
    y2: 110,
    stroke: "#e0aaff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 100,
    x2: 780,
    y2: 120,
    stroke: "#e0aaff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 100,
    x2: 820,
    y2: 130,
    stroke: "#e0aaff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 200,
    x2: 1240,
    y2: 210,
    stroke: "#e0aaff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 200,
    x2: 1180,
    y2: 220,
    stroke: "#e0aaff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 200,
    x2: 1220,
    y2: 230,
    stroke: "#e0aaff",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,300 L115,325 L100,350 L75,350 L60,325 L75,300 Z",
    fill: "#ffb6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500,100 L515,125 L500,150 L475,150 L460,125 L475,100 Z",
    fill: "#ffb6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900,200 L915,225 L900,250 L875,250 L860,225 L875,200 Z",
    fill: "#ffb6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300,150 L1315,175 L1300,200 L1275,200 L1260,175 L1275,150 Z",
    fill: "#ffb6d5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,50 L250,50",
    stroke: "#e0aaff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,50 L250,150",
    stroke: "#e0aaff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,150 L350,150",
    stroke: "#e0aaff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700,30 L900,30",
    stroke: "#e0aaff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900,30 L900,130",
    stroke: "#e0aaff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900,130 L1000,130",
    stroke: "#e0aaff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200,70 L1400,70",
    stroke: "#e0aaff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200,70 L1200,170",
    stroke: "#e0aaff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200,170 L1100,170",
    stroke: "#e0aaff",
    strokeWidth: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 800,
    fill: "url(#gradient)",
    opacity: 0.15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffb6d5",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#e0aaff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#c77dff",
    stopOpacity: 0.05
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.057c860b3aa4940ecf2ea5968b8cb9bb.svg";
export { ForwardRef as ReactComponent };